import { v4 as uuidv4 } from 'uuid';
import { updateLabel, createLabel } from '@/api/label';
import { timeFormat } from '@/utils/other';

type IUpdateLabelInfo = ILabel.IModel.IUpdateLabelInfo;

export default class LabelClass implements ILabel.IModel.ILabelClass {
  public color = '';
  public comment = '';
  public createdName = '';
  public id = '';
  public active = true;
  public isPubilc = true;
  public name = '';
  private createdOnForUtc = '';
  get createdOn() {
    if (this.createdOnForUtc) {
      return timeFormat(this.createdOnForUtc, 'YYYY-MM-DD');
    }
    return '';
  }
  set createdOn(val: string) {
    this.createdOnForUtc = val; // 输入的时间字符串是世界标准时间
  }
  constructor(labelInfo?: ILabel.IResponse.ILabelInfo) {
    if (labelInfo) {
      Object.assign(this, labelInfo);
    } else {
      this.id = uuidv4();
    }
  }

  get getUpdateInfo(): IUpdateLabelInfo {
    return {
      name: this.name,
      isPubilc: this.isPubilc,
      color: this.color || '#61bd4f',
      comment: this.comment,
      active: this.active,
    };
  }
  public requestCreateLabel(updateParams: IUpdateLabelInfo): Promise<string> {
    return new Promise((reslove, reject) => {
      createLabel({
        id: this.id,
        data: {
          ...updateParams,
        },
      }).then((res) => {
        this.updateLabelInfo(updateParams);
        reslove('Success');
      }).catch((error) => {
        reject(error.message);
      });
    });
  }
  public requestUpdateLabel(updateParams: IUpdateLabelInfo): Promise<string> {
    return new Promise((reslove, reject) => {
      updateLabel({
        id: this.id,
        data: {
          ...updateParams,
        },
      }).then((res) => {
        this.updateLabelInfo(updateParams);
        reslove('Success');
      }).catch((error) => {
        reject(error.message);
      });
    });
  }
  public updateLabelInfo(updateParams: IUpdateLabelInfo): void {
    Object.keys(updateParams).forEach((key) => {
      switch (key) {
        case 'name':
          this[key] = updateParams[key];
          break;
        case 'isPubilc':
          this[key] = updateParams[key];
          break;
        case 'color':
          this[key] = updateParams[key];
          break;
        case 'comment':
          this[key] = updateParams[key];
          break;
        case 'active':
          this[key] = updateParams[key];
          break;
      }
    });
  }
}
